import { Spin } from 'antd'
import React from 'react'
import styled from 'styled-components'

const LoaderContainer = styled.div`
  padding: 30px 50px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const Loader = () => {
  return (
    <LoaderContainer>
      <div style={{ width: '120px' }}>
        <Spin tip="Chargement" size="large">
          <div className="content" />
        </Spin>
      </div>
    </LoaderContainer>
  )
}
